export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./info_adicional.vue?vue&type=template&id=ccf54306&"


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/Map/Details/info_adicional.vue?vue&type=template&id=ccf54306&
// module id = null
// module chunks = 